import React, {Fragment, useContext, useEffect, useState} from "react";
import IconBtn from "../../../../../CommonElements/IconButton";
import axiosConfig from "../../../../../Config/axios";
import {getApplicationRoute} from "../../../../../Route/RouteIndex";
import Loader from "../../../../../Layout/Loader";
import DataTable from "react-data-table-component";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {Board, BoardsTableProps} from "../../Types/BoardTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import WalletContext from "../../../Wallet/Context";
import {WalletContextType} from "../../../Wallet/Context/WalletContext.types";

const BoardsTable: React.FC<BoardsTableProps> = ({params, reload = false}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [boards, setBoards] = useState<Board[]>([])
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);
    const [totalRows, setTotalRows] = useState<number>(0);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const walletContext = useContext(WalletContext) as WalletContextType;
    const {errorHandler} = authContext || {};
    const {getFormattedAmount} = walletContext || {};
    const getBoards = (page?: number, limit?: number) => {
        setLoaderVisibility(true);
        const currentPageToUse = page ?? currentPage;
        const limitToUse = limit ?? perPage;
        const config = {params: {...params, page: currentPageToUse, per_page: limitToUse}};
        axiosConfig
            .get(getApplicationRoute('board'), config)
            .then((response: any) => {
                if (response?.data?.data?.data) {
                    setBoards(response.data.data.data);
                }
                if (response?.data?.data?.meta) {
                    setCurrentPage(response.data.data.meta.current_page);
                    setPerPage(response.data.data.meta.per_page);
                    setTotalRows(response.data.data.meta.total);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        getBoards(1, 10);
    }, [params, reload])

    const deleteBoard = (id: number) => {
        setLoaderVisibility(true);
        axiosConfig
            .delete(`${getApplicationRoute('board')}/${id}`, {})
            .then((response: { data: { data: { id: number; }; }; }) => {
                if (response?.data?.data) {
                    setBoards(current => current.filter(boardItem => {
                        return boardItem.id !== response?.data?.data?.id;
                    }));
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }


    const boardTableColumns = [
        {
            name: 'Name', selector: (row: Board) => row.name, sortable: false,
        },
        {
            name: 'Date', selector: (row: Board) => row.date, sortable: true, center: true,
        },
        {
            name: 'Value',
            cell: (row: Board) => <div>{row.booking_types?.map((bookingType, key) => <div
                key={key}>
                {bookingType.booking_type}
                <div className='d-flex align-items-center gap-1' title='Points Wallet Balance'>
                            <span className={`badge badge-light-primary m-r-20`}>
                                Points
                            </span>
                    <span>{getFormattedAmount((bookingType.amount * (row.number_of_slots || 0)), 'wallet-type-points', 1)}</span>
                </div>
            </div>)}</div>,
            sortable: true,
            center: true,
            wrap: true
        },
        {
            name: 'Collector',
            selector: (row: Board) => row.collectors_names || row.collector_name || '',
            sortable: true,
            center: true,
        },
        {
            name: 'Participants',
            selector: (row: Board) => row.number_of_participants || 0,
            sortable: true,
            center: true,
        },
        {
            name: 'Winning Number',
            selector: (row: Board) => row.winning_number ?? row.winning_board_number?.winning_number ?? '-',
            sortable: true,
            center: true,
        },
        {
            name: 'Option', selector: (row: Board) => <div className='d-flex align-items-right gap-2'>
                <IconBtn link={`${getApplicationRoute('board')}/${row.id}`} type={'view'} permission={'read-board'}/>
                <IconBtn confirm={true} onclick={() => deleteBoard(row.id)} type={'delete'}
                         permission={'delete-board'}/>
            </div>, sortable: false, right: true,
        }]
    return <Fragment>
        <Loader visibility={loaderVisibility}/>
        <DataTable pagination paginationServer columns={boardTableColumns}
                   data={boards}
                   paginationTotalRows={totalRows}
                   paginationPerPage={perPage}
                   paginationDefaultPage={currentPage}
                   onChangePage={(page) => getBoards(page, perPage)}
                   onChangeRowsPerPage={(newPerPage, page) => {
                       setPerPage(newPerPage);
                       getBoards(page, newPerPage);
                   }}
                   highlightOnHover={true}
                   striped={true} responsive={true}/>
    </Fragment>
}

export default BoardsTable;
